/**
 * Created by filatov on 16.09.2015.
 */
import LeaveHTMLPreviewBaseColumnsStrategy from './LeaveHTMLPreviewBaseStrategy'

export default function LeaveHTMLPreviewBalanceOnlyStrategy() {}

LeaveHTMLPreviewBalanceOnlyStrategy.prototype = new LeaveHTMLPreviewBaseColumnsStrategy();

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.init = function( timeFormat, balanceQualifier )
{
    LeaveHTMLPreviewBaseColumnsStrategy.prototype.init.call( this, timeFormat );

    this.balanceColumnsRender = this._initBalanceColumnsRenderConstructor(balanceQualifier, false);
    return this;
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addFirstHeaderRowCells = function( firstHeaderRow )
{
    this.balanceColumnsRender.addHeaderFirstRowCells(firstHeaderRow);
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addSecondHeaderRowCells = function( secondHeaderRow )
{
    this.balanceColumnsRender.addHeaderSecondRowCells(secondHeaderRow);
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.getStrategyCssClass = function ()
{
    return "balanceOnly"  + " " + this.balanceColumnsRender.getRenderSpecificCssClass();
};

LeaveHTMLPreviewBalanceOnlyStrategy.prototype.addDataCells = function( row )
{
    this.balanceColumnsRender.addValueCells(row);
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/leave/LeaveHTMLPreviewBalanceOnlyStrategy.js